<template>
  <el-container>
    <el-header>
      <label class="title-font-size">会員登録メニュー</label>
    </el-header>
    <el-main>
      <div class="memberscard-image">
        <img alt="新規会員登録はこちら" src="@/assets/new_member_card1.png" @click="newmember" />
      </div>
      <div class="memberscard-image">
        <img alt="会員カードをお持ちの方はこちら" src="@/assets/exist_member_card1.png" @click="cardmember" />
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  methods: {
    newmember: function () {
      this.$router.push({ name: "MemberRegist", params: {} });
    },
    cardmember: function () {
      this.$router.push({ name: "MemberAuthentication", params: {} });
    },
  }
};
</script>

<style scoped>
.el-container {
  height: 100%;
}
.el-header {
  height:12%;
  display: -webkit-flex;
  align-items:center;
}
.el-main {
  height:87%;
}
.daito-button {
  background-color: #ffa500;
  color: #ffff;
  width: 80vw;
  height: 9.5vh;
  font-weight: bold;
  font-size: 4.0vw;
  border-radius: 7px;
  display: block;
  margin:0 auto;
  border-color: #636363;
}
.memberscard-image {
  display: -webkit-flex;
  justify-content: center;
  margin-top: 30px;
}
.memberscard-image img {
  position: relative;
  width: 80%;
  height: auto;
}
</style>
